import React from 'react';
import { withRouter } from 'react-router-dom';

import clientIcon from '../../../assets/img/client_icon.svg';
import whiteArrowDown from '../../../assets/img/white-arrow-down.svg';

import AccountManagementRecordSelect from '../AccountManagementRecordSelect/AccountManagementRecordSelect';
import AppBarLeft from './components/AppBarLeft';

import styles from './AppBar.module.css';

const BufflBar = ({
  clientEmail,
  history,
  isAuthenticated,
  onGoToPortalPage,
  onLogout,
  path,
  isFetching,
  appBarProperties,
  onSearchCampaigns,
  builder = false,
  isAdmin,
  isProfilingTagsManager,
  isBusinessConfigurationManager,
  accountManagement,
  setSelectedAccountManagementRecord
}) => (
  <header
    className={`${styles.appBarContainer} ${
      builder ? styles.appBarBuilder : ''
    } ${
      appBarProperties && appBarProperties.absolutePosition
        ? styles.appBarAbsolute
        : ''
    }`}
  >
    <div className={styles.appBarLeft}>
      <AppBarLeft
        history={history}
        isAuthenticated={isAuthenticated}
        onGoToPortalPage={onGoToPortalPage}
        path={path}
        isFetching={isFetching}
        appBarProperties={appBarProperties}
        onSearchCampaigns={onSearchCampaigns}
      />
    </div>
    <div className={`${styles.appBarRight} app-bar-right`}>
      {accountManagement &&
      accountManagement.multipleAccountManagementRecordsToSelect ? (
        <div
          className={`${
            styles.appBarButtonsContainer
          } app-bar-buttons-container`}
        >
          <AccountManagementRecordSelect
            accountManagement={accountManagement}
            onSelect={setSelectedAccountManagementRecord}
            hideNoValueOption={accountManagement && !isAdmin}
            fixedLeftPadding={200}
            isAdmin={isAdmin}
          />
        </div>
      ) : null}
      {isAuthenticated ? (
        <div className={styles.authContainer}>
          <img src={clientIcon} alt="Client icon" />
          <img src={whiteArrowDown} alt="Arrow down" height="5" />
          <div className={styles.dropdownContent}>
            <div className={styles.clientEmail}>{clientEmail}</div>
            {isAdmin && (
              <div
                className={styles.clientLogout}
                onClick={() => history.push('/coupons')}
                role="presentation"
              >
                Coupon Management
              </div>
            )}
            {isProfilingTagsManager ? (
              <div
                className={styles.clientLogout}
                onClick={() => history.push('/profile-tags-management')}
                role="presentation"
              >
                Profile Tags Management
              </div>
            ) : null}
            {isAdmin ? (
              <div
                className={styles.clientLogout}
                onClick={() => history.push('/feasibility-checker')}
                role="presentation"
              >
                Feasibility Checker
              </div>
            ) : null}
            {isAdmin ? (
              <div
                className={styles.clientLogout}
                onClick={() => history.push('/community-dashboard')}
                role="presentation"
              >
                Community Dashboard
              </div>
            ) : null}
            {isAdmin ? (
              <div
                className={styles.clientLogout}
                onClick={() => history.push('/community-automations')}
                role="presentation"
              >
                Community Automations
              </div>
            ) : null}
            {isBusinessConfigurationManager ? (
              <div
                className={styles.clientLogout}
                onClick={() => history.push('/business-configuration')}
                role="presentation"
              >
                Business Challenge Configuration
              </div>
            ) : null}
            <div
              className={styles.clientLogout}
              onClick={() => history.push('/account-management')}
              role="presentation"
            >
              Account Management
            </div>
            {isAdmin ? (
              <>
                <div
                  className={styles.clientLogout}
                  onClick={() => history.push('/notifications/push')}
                  role="presentation"
                >
                  Communication center
                </div>
                <div
                  className={styles.clientLogout}
                  onClick={() => history.push('/acquisition-metrics')}
                  role="presentation"
                >
                  Acquisition Metrics
                </div>
              </>
            ) : null}
            <div
              className={styles.clientLogout}
              onClick={() => {
                onLogout();
                if (history) {
                  history.push('/auth/login');
                }
              }}
              role="presentation"
            >
              Logout
            </div>
          </div>
        </div>
      ) : null}
    </div>
  </header>
);
export default withRouter(BufflBar);
